module.exports = __webpack_public_path__ + "img/jiaowu_mobile6.db7f86d3.jpg";